import React, { memo } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { ADMISSION_COLORS as C } from "../constants/admissionTheme";

function PageHeader({ title, subtitle, actions }) {
  return (
    <Box
      component="header"
      sx={{
        px: { xs: 2, md: 3 },
        py: 2,
        borderBottom: `1px solid ${C.border}`,
        bgcolor: C.cardBg,
        boxShadow: C.shadow.card,
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={2}
      >
        <Box>
          <Typography variant="h5" component="h1" fontWeight={700} color={C.textPrimary}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color={C.textSecondary} sx={{ mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && (
          <Stack direction="row" flexWrap="wrap" gap={1} useFlexGap>
            {actions}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}

export default memo(PageHeader);
